import { Button } from '@/components/ui/button';
import { MapPin, Edit, Trash2 } from 'lucide-react';

/**
 * Card component for displaying a single location
 */
export default function LocationCard({ location, onEdit, onDelete }) {
  return (
    <div className="group relative bg-white rounded-xl border-2 border-slate-200 hover:border-teal-400 hover:shadow-xl transition-all duration-300 overflow-hidden">
      {/* Gradient top border */}
      <div className="h-1 bg-gradient-to-r from-teal-500 to-blue-500"></div>
      
      <div className="p-4">
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 bg-gradient-to-br from-teal-100 to-blue-100 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform">
              <span className="font-bold text-2xl bg-gradient-to-br from-teal-600 to-blue-600 bg-clip-text text-transparent">
                {location.letter}
              </span>
            </div>
            <div>
              <div className="font-bold text-slate-900 text-lg">{location.name}</div>
              <div className="text-xs text-slate-500">Lokalitet {location.letter}</div>
            </div>
          </div>
        </div>
        
        {location.latitude && location.longitude && (
          <div className="mb-3 p-2 bg-slate-50 rounded-lg">
            <div className="flex items-start space-x-2 text-xs">
              <MapPin className="w-3 h-3 text-teal-600 mt-0.5 flex-shrink-0" />
              <div className="font-mono text-slate-600">
                <div>{location.latitude.toFixed(4)}°N</div>
                <div>{location.longitude.toFixed(4)}°E</div>
              </div>
            </div>
          </div>
        )}
        
        {location.address && (
          <div className="mb-3 text-xs text-slate-600 line-clamp-2">
            {location.address}
          </div>
        )}
        
        <div className="flex space-x-2 pt-3 border-t border-slate-200">
          <Button
            variant="outline"
            size="sm"
            onClick={() => onEdit(location)}
            className="flex-1 h-9 text-xs hover:border-teal-500 hover:bg-teal-50 hover:text-teal-700"
          >
            <Edit className="w-3 h-3 mr-1" />
            Rediger
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onDelete(location.id)}
            className="h-9 w-9 p-0 text-red-500 hover:text-red-700 hover:bg-red-50"
          >
            <Trash2 className="w-3 h-3" />
          </Button>
        </div>
      </div>
    </div>
  );
}
